import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, LOGIN_PAGE_URL } from "./settings";

class TokenStorageService {
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  clearTokens(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  clearTokensAndRedirectToLoginPage(): void {
    this.clearTokens();
    window.location.href = LOGIN_PAGE_URL;
  }
}

export const tokenStorage = new TokenStorageService();
